var _radialGradient, _radialGradient2, _linearGradient, _linearGradient2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLamp1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 152.92 280.49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 258.3,
    width: 152.5,
    height: 17.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1,269.9c-.1,0-.2-.1-.4-.1a45.2,45.2,0,0,1-.6-5.3h0c.3,1.9.6,3.7,1,5.4",
    style: {
      fill: "none"
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_37",
    "data-name": "Sfumatura senza nome 37",
    cx: 1624.29,
    cy: -1032.08,
    r: 3.25,
    gradientTransform: "matrix(2.6, -14.7, 22.35, 3.07, 18918.89, 27311.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2,275.9h0c-33.4,0-61.8-2.5-72.1-5.9a50.67,50.67,0,0,1-.9-5.4c3.1-1.2,8.4-2.3,15.3-3.2H133.9a87.18,87.18,0,0,1,14.8,3,46,46,0,0,1,.6,5.2c-9.4,3.6-38.5,6.3-73.1,6.3",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2,261.3c-6.5,0-12.9.1-18.9.2,3.4,4.4,10.6,7.4,18.9,7.4s15.5-3,18.9-7.4C89.1,261.4,82.8,261.3,76.2,261.3Z",
    style: {
      fill: "none"
    }
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_38",
    "data-name": "Sfumatura senza nome 38",
    cx: 1207.3,
    cy: -936.82,
    r: 3.25,
    gradientTransform: "translate(-5624.54 4682.37) scale(4.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f8a8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.4,
    y: 60.9,
    width: 3.7,
    height: 192.1,
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_39",
    "data-name": "Sfumatura senza nome 39",
    x1: -176.88,
    y1: -982.65,
    x2: -173.63,
    y2: -982.65,
    gradientTransform: "translate(275.17 1272.45) scale(1.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757871"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 205.4,
    width: 152.4,
    height: 62,
    style: {
      fill: "none"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_40",
    "data-name": "Sfumatura senza nome 40",
    x1: 1687.8,
    y1: -942.22,
    x2: 1691.05,
    y2: -942.22,
    gradientTransform: "translate(79787.04 -44219.25) rotate(180) scale(47.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#636566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#262625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#1d1d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2c2d2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#464847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585b5b"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g4978"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4986",
    d: "M3.8,269.8C1.3,268.9,0,268,0,267.1H0c0-.9,1.1-1.7,3.2-2.5a46,46,0,0,0,.6,5.2m145.5-.2a43.5,43.5,0,0,0-.6-5.2c2.4.8,3.7,1.7,3.7,2.7v.1c0,.8-1.1,1.6-3.1,2.4m-15.4-8.3H18.5c14-1.9,34.6-3,57.7-3h0c23.1,0,43.7,1.2,57.7,3",
    transform: "translate(0.52)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4988"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5002",
    d: "M4.1,269.9c-.1,0-.2-.1-.4-.1a45.2,45.2,0,0,1-.6-5.3h0c.3,1.9.6,3.7,1,5.4",
    transform: "translate(0.52)",
    style: {
      fill: "url(#Sfumatura_senza_nome_37)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5004"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5012"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image5014",
    width: 75,
    height: 11,
    transform: "translate(0 257.67) scale(2.03 2.07)",
    xlinkHref: "../../../../Pictures/alldev/furnitures/3ABF75C5.png",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "path5016",
    d: "M148.5,268.1c0,3.7-32.4,6.7-72.3,6.7s-72.3-3-72.3-6.7,32.4-6.7,72.3-6.7,72.3,3,72.3,6.7",
    transform: "translate(0.52)",
    style: {
      fill: "#fffdf5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5018"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5034",
    d: "M76.2,261.3c-6.5,0-12.9.1-18.9.2,3.4,4.4,10.6,7.4,18.9,7.4s15.5-3,18.9-7.4c-6-.1-12.3-.2-18.9-.2",
    transform: "translate(0.52)",
    style: {
      fill: "url(#Sfumatura_senza_nome_38)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g5036"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5050",
    d: "M74.4,252.9h3.7V60.8H74.4V252.9",
    transform: "translate(0.52)",
    style: {
      fill: "url(#Sfumatura_senza_nome_39)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path5052",
    d: "M86.1,44.3H66.4V0H86.1V44.3",
    transform: "translate(0.52)",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5054",
    d: "M76.3,66.4h-.2c0,.4-9.8-4.4-9.8-9.8V44.2H86V56.6c.1,5.5-9.7,9.8-9.7,9.8",
    transform: "translate(0.52)",
    style: {
      fill: "#1b1a1a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5056"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5082",
    d: "M152.4,267.4H0v-62H152.4v62",
    transform: "translate(0.52)",
    style: {
      fill: "url(#Sfumatura_senza_nome_40)"
    }
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLamp1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lamp1.78defff31425b185a3bfd1657b68e519.svg";